import styled from "styled-components";
// Mobile Playlist Drawer Styles
import { Drawer } from 'antd';

export const AudioPlayerStyle = styled.div`
  max-width: 100%;
  width: 100%;
  position: relative;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-gap: 20px;
  .images1 {
    height: 70px;
    margin-left: 30px;
  }

  .div3 {
    width: 20%;
  }
  .p2 {
    color: ${(props) => props.theme.colors.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    max-width: 250px;
  }
  .pp12 {
    color: ${(props) => props.theme.colors.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 19px;
    max-width: 250px;
    padding-top: 5px;
    margin-left: 5px;
  }
  .p4 {
    color: ${(props) => props.theme.colors.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
  .spanner1 {
    display: flex;
    align-items: center;
  }
  .spanner1 svg {
  }
  .spanner1 button {
    margin-right: 32px;
    background: transparent;
    border: none;
    cursor: pointer;
  }
  .audio-player {
    background: transparent;
    border: 0px;
    box-shadow: 0px;
    outline: none;

    width: 100%;

    .rhap_progress-section {
      div {
        color: ${(props) => props.theme.colors.primary};
      }
      @media only screen and (max-width: 600px) {
        .rhap_volume-container {
          display: none !important;
        }
      }
    }
    .rhap_container {
      width: 100%;
      padding: 0px 0px !important;
      box-shadow: 0 0 0px 0 rgb(0 0 0 / 0%) !important;
    }
    .rhap_controls-section {
      color: ${(props) => props.theme.colors.primary} !important;
    }

    .rhap_button-clear {
      color: ${(props) => props.theme.colors.primary};
      //   border-radius: 100px;
      //   background: white;
    }
  }

  .loop-button {
    background-color: transparent;
    border: none;
  }

  .SongSideBar {
    background: #111823 !important;
    padding: 25px;
    display: flex;
    left: 0;
    align-items: center;
    gap: 12px;
  }
  .SongSideBarImage img {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    object-fit: cover;
  }
  .SongSideBar .songDetail {
    margin-left: 0;
    height: auto;
    flex: 1;
    min-width: 0;
  }
  .SongSideBar .songDetail h2 {
    font-family: DM Sans;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.03em;
    text-align: left;
    color: white;
    margin: 0 0 4px 0;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .SongSideBar .songDetail p {
    font-family: DM Sans;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: -0.03em;
    text-align: left;
    color: #9ca3af;
    margin: 0 0 8px 0;
    
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .SongSideBar .songDetail .rhap_progress-section {
    display: none;
  }
  .SongSideBar .songDetail .rhap_container {
    background: transparent;
    border: none;
    box-shadow: unset;
    margin: 0;
    padding: 0;
  }
  @media only screen and (max-width: 768px) {
    .SongSideBar {
      display: none;
    }
    .sidebarForPc {
      display: none;
    }
    .sidebarForMob {
      display: block;
    }
  }
  @media only screen and (min-width: 769px) {
    .SongSideBar {
      position: fixed;
      bottom: 0;
      width: 230px;
      overflow: visible;
      height: 90px;
      padding: 0px 20px 0px 10px;
      display: flex;
      align-items: center;
      gap: 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.3);
      z-index: 1000;
    }
    .SongSideBarImage {
      margin-top: 8px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .SongSideBarImage img {
      height: 40px;
      width: 40px;
      border-radius: 8px;
      object-fit: cover;
    }
    .SongSideBar .songDetail {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-left: 0;
      height: auto;
      min-width: 0;
    }
    .SongSideBar .songDetail h2 {
      margin: 0;
      margin-top: 8px;
      font-size: 12px;
      font-weight: 600;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 150px;
    }
    .SongSideBar .songDetail p {
      margin: 0;
      font-size: 10px;
      font-weight: 400;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .SongSideBar .songDetail .rhap_container {
      padding: 0px;
      transform: scale(0.9);
      background: transparent;
      box-shadow: none;
      border: none;
      margin-top: 4px;
      width: 135px;
    }
    .SongSideBar .rhap_main-controls {
      padding: 0;
      gap: 8px;
      justify-content: flex-start;
    }
    .SongSideBar .rhap_button-clear {
      width: 32px;
      height: 32px;
      font-size: 14px;
      border-radius: 50%;
      transition: all 0.2s ease;
    }
    .SongSideBar .rhap_button-clear:hover {
      transform: scale(1.05);
    }
    .SongSideBar .rhap_play-pause-button svg {
      width: 32px;
      height: 32px;
    }
    .SongSideBar .rhap_additional-controls,
    .SongSideBar .rhap_volume-container {
      display: none !important;
    }
    .SongSideBar .audioPlayer {
      position: unset;
      transform: unset;
      max-width: none;
      width: 100%;
    }
    .SongSideBar .rhap_progress-section {
      display: none;
    }
  }

  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    .SongSideBarImage img {
      height: 50px;
      width: 50px;
    }
    .SongSideBar .songDetail h2 {
      font-size: 14px;
    }
    .SongSideBar .songDetail p {
      font-size: 12px;
    }
    .SongSideBar .rhap_button-clear {
      width: 28px;
      height: 28px;
      font-size: 12px;
    }
  }

`;

export const AudioPlayerStyle1 = styled.div`
  z-index: 100;
  position: relative;
  .titler {
    color: ${(props) => props.theme.colors.primary};
  }
  .div {
    /* Match Sidebar V2 background color */
    background: #111823;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding: 10px;
    overflow: hidden;
    padding: 0px;
  }
  .spanner {
    position: fixed;
    bottom: 146px;
    z-index: 101;
    cursor: pointer;
    left: 277px;
  }

  .AudioPlayerStyleClassName {
    display: flex;
    align-items: center;
    width: auto;
  }

  .AudioPlayerStyleClassNameDiv {
    display: block;
    // width: 20%;
    margin-left: 20px;
  }

  .AudioPlayerStyleClassNameImage {
    height: 121px;
    margin-left: 10px;
    width: auto;
  }

  .AudioPlayerStyleClassNameImageTwo {
    height: 121px;
    margin-left: 30px;
    width: auto;
  }

  .AudioPlayerpreviewSongStyleclassName {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .AudioPlayerpreviewSongStyleclassName.active {
    padding: 24px;
    height: 80px;
  }

  .audioPlayer {
    max-width: 428px;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0.8);
  }

  .spanner {
    // transform: rotateZ(0deg);
  }

  .AudioPlayerStyleClassNameFlexbox {
    display: none !important;
    height: auto;
  }

  .rhap_container {
    width: 100%;
    box-shadow: 0 0 0px 0 rgb(0 0 0 / 0%) !important;
  }
  .rhap_main-controls {
    padding: 18px 0px;
  }

  .rhap_stacked-reverse {
    margin-bottom: 24px;
  }

  .bottomNav {
    display: none;
    align-items: stretch;
    justify-content: space-around;
    background: #0a0e14;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    padding: 8px 4px 10px 4px;
    gap: 0;
  }
  
  .bottomBarNav {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px 4px;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.15s ease;
    border-radius: 8px;
    
    svg {
      width: 20px;
      height: 20px;
      color: rgba(255, 255, 255, 0.45);
      transition: all 0.15s ease;
      flex-shrink: 0;
    }
    
    span {
      font-size: 10px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.45);
      letter-spacing: 0.2px;
      transition: all 0.15s ease;
      text-align: center;
      line-height: 1.2;
    }
    
    &:active {
      transform: scale(0.95);
    }
    
    &:hover, &.active {
      svg {
        color: #3b82f6;
      }
      
      span {
        color: #3b82f6;
      }
    }
  }
  @media only screen and (max-width: 5000px) {
    .AudioPlayerStyleClassNameImage,
    .AudioPlayerStyleClassNameImageTwo {
      height: 51px;
      margin-left: 0px;
    }
    .AudioPlayerpreviewSongStyleclassName.active {
      padding: 14px 24px;
      height: 80px;
    }
    .spanner {
      bottom: 59px;
      left: 212px;
    }
  }
  @media only screen and (max-width: 768px) {
    .bottomNav {
      display: flex;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      padding: 6px 8px calc(6px + env(safe-area-inset-bottom, 0px)) 8px;
    }
    
    .bottomBarNav {
      svg {
        width: 22px;
        height: 22px;
      }
      
      span {
        font-size: 9px;
      }
    }

    .AudioPlayerStyleClassName {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20%;

      height: 48px;
      position: absolute;
      left: 0px;
      width: 48px;
    }
    .audioPlayer {
      max-width: 100%;
    }
    .rhap_volume-container {
      display: none !important;
    }

    .AudioPlayerStyleClassNameImage {
      height: 80px;
      margin-left: 0px;
      width: 100%;
    }

    .AudioPlayerStyleClassNameDiv {
      display: contents;
      width: 100%;
    }

    .AudioPlayerStyleClassNameImageTwo {
      height: 80px !important;
      margin-left: 0px;
      width: 100%;
    }

    .div {
      padding: 0px 0px 0px 0px;
    }

    .AudioPlayerpreviewSongStyleclassName {
      padding: 0px 0px 0px 0px;
      height: 0px !important;
      overflow: hidden;
      transition: 0.2s !important;
      padding: 0px !important;
    }
    .SongPlaying {
      height: 48px !important;
      padding: 0px !important;
    }
    .pp12 {
      padding: 0px;
      max-width: unset;
      font-size: 14px;
      padding-left: 48px;
    }
    .spanner {
      bottom: 270px;
      margin-left: 85%;
      transform: rotateZ(90deg);
    }

    .AudioPlayerStyleClassNameFlexbox {
      display: flex;
      justify-content: space-around;
      // height: 85px;
      // margin-bottom: 2%;
      // overflow: scroll;
    }

    .tab:hover {
      padding: 10px 10px 10px 10px;
      background: #5dabffb0;
      border-radius: 14px;
      border-bottom: 5px solid #007aff;
      margin-left: 10px;
    }

    .tab:hover {
      padding: 10px 10px 10px 10px;
      background: #5dabffb0;
      border-radius: 14px;
      border-bottom: 5px solid #007aff;
      margin-left: 10px;
    }

    .tab:active {
      padding: 10px 10px 10px 10px;
      background: #5dabffb0;
      border-radius: 14px;
      border-bottom: 5px solid #007aff;
      margin-left: 10px;
    }

    .tab:active {
      padding: 10px 10px 10px 10px;
      background: #5dabffb0;
      border-radius: 14px;
      border-bottom: 5px solid #007aff;
      margin-left: 10px;
    }

    .tab:focus {
      padding: 10px 10px 10px 10px;
      background: #5dabffb0;
      border-radius: 14px;
      border-bottom: 5px solid #007aff;
      margin-left: 10px;
    }

    .tab:focus {
      padding: 10px 10px 10px 10px;
      background: #5dabffb0;
      border-radius: 14px;
      border-bottom: 5px solid #007aff;
      margin-left: 10px;
    }

    .AudioPlayerFlexbox {
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
    }

    .title1 {
      font-size: 14px;
      color: ${(props) => props.theme.colors.primary1};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 25ch;
    }

    .tab {
      display: flex;
      flex-direction: column;
      justify-content: center;

      padding-left: 0px;
      align-items: center;
      width: calc(100% / 4);
    }

    .AudioPlayerStyleClassNameFlexbox1 {
      width: 100%;
      height: 3px;
      background: #1c1c1c;
      margin-top: 4%;
      margin-bottom: 2%;
    }
    .audioPlayerInner {
      width: 100%;
      display: flex;
    }
    .audioPlayerInner .AudioPlayerStyleClassName {
      // display:none;
    }
    .audioPlayer {
      position: relative !important;
      transform: unset;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      left: 0px;
      .rhap_time {
        display: none;
      }
      .rhap_progress-indicator {
        display: none;
      }
      .rhap_progress-container {
        margin: 0px;
        height: 0px;
      }
      .rhap_progress-bar.rhap_progress-bar-show-download {
        left: 0px;
        position: absolute;
      }
      .rhap_progress-bar {
        height: 3px;
      }
      .rhap_rewind-button,
      .rhap_forward-button {
        display: none;
      }
      .rhap_container {
        width: auto;
        padding: 0px;
        padding-right: 10px;
      }
      .rhap_play-pause-button svg {
        width: 30px;
      }
    }
  }

  @media only screen and (min-width: 5000px) {
    .spanner {
      margin-left: 13%;
    }
  }

  .rhap_container {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  
  .rhap_controls-section {
    margin-bottom: 0px;
  }
`;


export const MobilePlaylistDrawerStyle = styled(Drawer)`
  .ant-drawer-content {
    background: #0B0F1B;
    border-radius: 0 20px 20px 0;
  }

  .ant-drawer-body {
    padding: 0;
    overflow: hidden;
  }

  .ant-drawer-header {
    display: none;
  }

  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px 16px 20px;
    background: linear-gradient(180deg, rgba(0, 122, 255, 0.08) 0%, transparent 100%);

    h2 {
      font-size: 22px;
      font-weight: 700;
      color: #fff;
      margin: 0;
      letter-spacing: -0.3px;
    }

    .close-btn {
      background: rgba(255, 255, 255, 0.06);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      svg {
        color: #b8b8b8;
        width: 18px;
        height: 18px;
      }

      &:active {
        transform: scale(0.92);
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }

  .actions-row {
    display: flex;
    gap: 12px;
    padding: 0 20px 16px 20px;

    .action-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 12px 20px;
      border-radius: 12px;
      border: none;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.25);

      &.create-btn {
        background: #007AFE;
        color: #fff;
        flex: 1;

        svg {
          width: 18px;
          height: 18px;
        }

        &:active {
          transform: scale(0.97);
          background: #0056cc;
        }
      }
    }
  }

  .search-container {
    position: relative;
    padding: 0 20px;
    margin-bottom: 16px;

    .search-icon {
      position: absolute;
      left: 36px;
      top: 50%;
      transform: translateY(-50%);
      color: #6b7280;
      pointer-events: none;
    }

    input {
      width: 100%;
      padding: 14px 44px 14px 44px;
      background: #111823;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 12px;
      color: #fff;
      font-size: 15px;
      outline: none;
      transition: all 0.2s ease;

      &::placeholder {
        color: #6b7280;
      }

      &:focus {
        border-color: #007AFE;
        background: #151c28;
        box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
      }
    }

    .clear-search {
      position: absolute;
      right: 32px;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.08);
      border: none;
      border-radius: 8px;
      width: 28px;
      height: 28px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.15s ease;

      svg {
        color: #6b7280;
        width: 12px;
        height: 12px;
      }

      &:active {
        background: rgba(255, 255, 255, 0.12);
        transform: translateY(-50%) scale(0.9);
      }
    }
  }

  .playlist-list {
    flex: 1;
    overflow-y: auto;
    padding: 0 12px 20px 12px;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #007AFE;
      border-radius: 8px;
    }
  }

  .playlist-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px;
    margin-bottom: 6px;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: transparent;
    border: 1px solid transparent;

    &:active {
      transform: scale(0.98);
    }

    &:hover {
      background: rgba(255, 255, 255, 0.04);
    }

    &.active {
      background: rgba(0, 122, 255, 0.1);
      border-color: rgba(0, 122, 255, 0.2);

      .playlist-name {
        color: #007AFE;
      }

      .active-indicator svg {
        color: #007AFE;
      }
    }

    .playlist-image {
      width: 52px;
      height: 52px;
      border-radius: 10px;
      overflow: hidden;
      flex-shrink: 0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .placeholder-image {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #1a2332 0%, #111823 100%);

        svg {
          color: rgba(255, 255, 255, 0.25);
          width: 22px;
          height: 22px;
        }
      }
    }

    .playlist-info {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .playlist-name {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: -0.2px;
      }

      .playlist-tracks {
        font-size: 13px;
        color: #b8b8b8;
      }
    }

    .active-indicator {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 122, 255, 0.15);
      border-radius: 50%;
      
      svg {
        color: #007AFE;
        width: 14px;
        height: 14px;
      }
    }
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    gap: 16px;

    .spinner {
      width: 32px;
      height: 32px;
      border: 3px solid rgba(255, 255, 255, 0.08);
      border-top-color: #007AFE;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }

    span {
      font-size: 14px;
      color: #b8b8b8;
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
    gap: 16px;

    svg {
      color: rgba(255, 255, 255, 0.15);
      width: 48px;
      height: 48px;
    }

    p {
      font-size: 15px;
      color: #b8b8b8;
      margin: 0;
    }
  }

  .load-more-btn {
    width: calc(100% - 24px);
    margin: 12px 12px 0 12px;
    padding: 14px;
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #007AFE;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:active {
      transform: scale(0.98);
      background: #151c28;
    }

    &:hover {
      border-color: rgba(0, 122, 255, 0.3);
      background: rgba(0, 122, 255, 0.05);
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
